<div
    tabindex="-1"
    id="myModal"
    role="dialog"
    class="modal fade in">
    <div class="backdrop"></div>
    <div
        data-show="true"
        role="document"
        class="modal-dialog"
        [class]="modalSize">
        <div class="modal-content">
            <div class="modal-header">
                <button
                    type="button"
                    data-dismiss="modal"
                    aria-label="Close"
                    (click)="closeDialog('cancel')"
                    class="close">
                    <i class="nlrp-icon nlrp-icon-close"></i
                ></button>
                <h4 class="modal-title">{{title}}</h4>
            </div>
            <div class="modal-body">
                <div class="container-fluid well">
                    <div class="row">
                        <div class="col-xs-1">
                            @if (iconType === 'info') {
                                <i class="nlrp-icon nlrp-icon-info nlrp-36 infoImageFormat"> </i>
                            }
                            @if (iconType === 'warning') {
                                <i class="nlrp-icon nlrp-icon-warning nlrp-36 alertImageFormat"> </i>
                            }
                        </div>
                        <div class="col-xs-11">
                            <p class="alertMessageFormat">
                                <span [innerHTML]="confirmationText | sanitizeResource: 'html'"></span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-default nlr-btn-sm"
                    (click)="applyAndClose()"
                    >{{yes ? yes : "Yes"}}
                </button>
                <button
                    type="button"
                    class="btn nlr-btn-sm"
                    [ngClass]="{'btn-warning': !showCancel, 'btn-default': showCancel}"
                    (click)="closeDialog('no')"
                    >{{no ? no : "No"}}
                </button>
                @if (showCancel) {
                    <button
                        type="button"
                        class="btn btn-warning nlr-btn-sm"
                        (click)="closeDialog('cancel')"
                        >Cancel
                    </button>
                }
            </div>
        </div>
    </div>
</div>
